module.exports = __webpack_public_path__ + "static/img/masu.1312e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teams/img/masu.png
// module id = rYZP
// module chunks = 1